document.addEventListener('DOMContentLoaded', function () {
    const openBtns = document.querySelectorAll(' .pcmenu .reserve a, .sp_head p a');
    const modal = document.querySelector('.reserve_modal');
    const closeBtn = document.querySelector('.reserve_modal .close');
  
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.add('active');
      });
    });
  
    closeBtn.addEventListener('click', function () {
      modal.classList.remove('active');
    });
  
    // モーダル外クリックで閉じる（任意）
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('active');
      }
    });
  });
  